import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const before = ['You walk into class feeling unprepared, with no clear structure', 'You build every single lesson entirely from scratch, week after week', 'Your teaching materials are scattered across different folders, drives, and random files', 'You keep repeating the same explanations without a reliable reference to fall back on', 'Your lessons often feel improvised, with no clear structure from start to finish', 'You know your teaching could be much more organized and professional', 'You end every week feeling completely drained and overwhelmed'];
const after = ['You walk into every class with a clear plan, greater confidence, and far less stress', 'You put together complete lessons in under 5 minutes, without starting from scratch', 'All your teaching materials are in one place, clearly organized and ready to use', 'You deliver clear, structured lessons that your students actually understand and remember', 'You teach with a clear plan—not just a collection of grammar exercises', 'Your teaching feels more polished, organized and professional', 'You finish each week knowing what worked and what comes next'];
export function PainSection() {
  return <section className="w-full bg-navy px-5 py-12 sm:py-20" data-id="element-126" data-mp="g7raclm2n0j">
      <div className="mx-auto max-w-5xl" data-id="element-127" data-mp="ewrenvadzep">
        <div className="mx-auto max-w-2xl text-center" data-id="element-128" data-mp="38vrlpey0qbh6">
          <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-129" data-mp="38u6mvd4o86di">
            Do any of these sound familiar?
          </h2>
          <p className="mt-3 text-sm italic text-gold sm:text-base" data-id="element-130" data-mp="3in4bm109arkk">
            If even one of these sounds familiar, this system was built for you.
          </p>
        </div>
        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-131" data-mp="2q5ia5egcd7ct">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border-l-4 border-red-400 bg-maroon p-6 sm:p-8" data-id="element-132" data-mp="2q3yt3lmv2s9z">
            <h3 className="mb-5 text-lg font-bold text-white sm:text-xl" data-id="element-133" data-mp="ytvf09kb83hf">Without the system</h3>
            <PainList items={before} icon="x" data-id="element-134" data-mp="12uywf0i0a7kr" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border-l-4 border-gold bg-navy-mid p-6 sm:p-8" data-id="element-135" data-mp="12xbah2kn7xsj">
            <h3 className="mb-5 text-lg font-bold text-gold sm:text-xl" data-id="element-136" data-mp="k58uzujqmnjv">
              With The ESL Survival Vault™
            </h3>
            <PainList items={after} icon="check" data-id="element-137" data-mp="1qk9pdvt46xoc" />
          </motion.div>
        </div>
      </div>
    </section>;
}
function PainList({
  items,
  icon
}: {
  items: string[];
  icon: 'x' | 'check';
}) {
  const Icon = icon === 'x' ? XIcon : CheckIcon;
  return <ul className="space-y-3" data-id="element-138" data-mp="20o7zn1y1ko7k">
      {items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-139" data-mp="20qt3fwhwhe7y">
          <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${icon === 'x' ? 'bg-red-500/20 text-red-300' : 'bg-gold/15 text-gold'}`} data-id="element-140" data-mp="1vwyd4a7si0zw">
            <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-141" data-mp="1mymp8fyb5hb5" />
          </span>
          <span className="text-sm leading-relaxed text-white/85" data-id="element-142" data-mp="1hxgu6bh6dhyg">{item}</span>
        </li>)}
    </ul>;
}